export const en = {
    add_bonus_card: 'Add a loyalty card',
    number: 'Number',
    card: 'Card',
    number_placeholder: 'Specify the card number',
};
